export default __webpack_public_path__ + "static/media/globe.51f63d01.png";